var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultColor, useGetSize } from '../utils';
const MapPin = (_a) => {
    var { size: sizeProp, color = defaultColor } = _a, rest = __rest(_a, ["size", "color"]);
    const size = useGetSize(sizeProp);
    return (React.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, rest),
        React.createElement("path", { fill: color, d: "M12 19.514q2.936-2.628 4.491-5.04 1.557-2.412 1.557-4.226 0-2.735-1.737-4.496T12 3.99 7.69 5.752t-1.738 4.496q0 1.814 1.557 4.226T12 19.514m0 1.426q-.293 0-.584-.1a1.5 1.5 0 0 1-.53-.313 37 37 0 0 1-2.518-2.555 23 23 0 0 1-2.04-2.628 14 14 0 0 1-1.371-2.604q-.505-1.29-.505-2.492 0-3.462 2.24-5.605T12 2.5t5.309 2.143 2.24 5.605q0 1.201-.506 2.488a14.4 14.4 0 0 1-1.366 2.603 22 22 0 0 1-2.034 2.628 37 37 0 0 1-2.52 2.55 1.6 1.6 0 0 1-.53.318q-.296.105-.593.105m.002-9.075q.746 0 1.276-.531t.53-1.278-.532-1.276A1.75 1.75 0 0 0 12 8.25q-.747 0-1.277.531-.53.532-.53 1.278 0 .747.532 1.277.531.53 1.278.53" })));
};
export default MapPin;
